import { useEffect, useRef } from 'react';
import { toast } from '@/components/ui/sonner';
import { useLanguage } from '@/contexts/LanguageContext';

const DISMISSED_KEY = 'wren_update_dismissed_build';

export const UpdatePrompt = () => {
  const { t } = useLanguage();
  const hasShownRef = useRef(false);

  useEffect(() => {
    const handleUpdateAvailable = (e: Event) => {
      if (hasShownRef.current) return;

      const customEvent = e as CustomEvent;
      const buildTime = customEvent.detail?.buildTime;

      // Respect user dismissal for this specific build
      if (buildTime && localStorage.getItem(DISMISSED_KEY) === buildTime) {
        return;
      }

      hasShownRef.current = true;

      toast(t('pwa.update.title'), {
        description: t('pwa.update.description'),
        duration: 20000, // Give ADHD users time to notice and act
        action: {
          label: t('pwa.update.button'),
          onClick: () => {
            window.location.reload();
          },
        },
        onDismiss: () => {
          if (buildTime) {
            localStorage.setItem(DISMISSED_KEY, buildTime);
          }
        },
        cancel: {
          label: t('pwa.update.dismiss'),
          onClick: () => {
            if (buildTime) {
              localStorage.setItem(DISMISSED_KEY, buildTime);
            }
          },
        },
      });
    };

    window.addEventListener('sw:update-available', handleUpdateAvailable);
    return () => window.removeEventListener('sw:update-available', handleUpdateAvailable);
  }, [t]);

  return null;
};
